import router from "../../router/index";
import { Notification } from "element-ui";
import t from "@common/src/i18n/t";
const inventory = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {
    toInventoryQuery(state, partCodeArr) {
      let { href } = router.resolve({
        path: `/inventory/index?showAlert=1&partCodeArr=${partCodeArr.join()}`
      });
      window.open(href);
    }
  },
  actions: {
    async getPartsInventoryList({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/queryList", params);
      return data;
    },
    async generateBatchNumber({ rootState }, params = {}) {
      const data = await rootState.http("/inbound/generateStorageBatchNumber", params);
      return data;
    },
    async saveInWarehouse({ rootState }, params = {}) {
      const data = await rootState.http("/inbound/v2/saveInbound", params);
      return data;
    },
    async getInventoryListByParts({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/queryListByParts", params);
      return data;
    },
    async getInWarehouseList({ rootState }, params = {}) {
      const data = await rootState.http("/inbound/queryList", params);
      return data;
    },
    async getInWarehouseDetail({ rootState }, params = {}) {
      const data = await rootState.http("/inbound/getInbound", params);
      return data;
    },
    async inWarehouseComplete({ rootState }, params = {}) {
      const data = await rootState.http("/inbound/completed", params);
      return data;
    },
    async inWarehouseCancel({ rootState }, params = {}) {
      const data = await rootState.http("/inbound/cancel", params);
      return data;
    },
    async saveOutWarehouse({ rootState }, params = {}) {
      const data = await rootState.http("/outbound/saveOutbound", params);
      return data;
    },
    async getOutWarehouseList({ rootState }, params = {}) {
      const data = await rootState.http("/outbound/queryList", params);
      return data;
    },
    async getOutWarehouseDetail({ rootState }, params = {}) {
      const data = await rootState.http("/outbound/getOutbound", params);
      return data;
    },
    async outWarehouseComplete({ rootState }, params = {}) {
      const data = await rootState.http("/outbound/completed", params);
      return data;
    },
    async outWarehouseCancel({ rootState }, params = {}) {
      const data = await rootState.http("/outbound/cancel", params);
      return data;
    },
    async getInventoryRecord({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/queryInventoryDetail", params);
      return data;
    },
    async saleTypeSaveOutbound({ rootState }, params = {}) {
      const data = await rootState.http("/outbound/saveDetail", params);
      return data;
    },
    async queryPartsInventoryOnBatch({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/queryInventoryByPartsCodeArray", params);
      return data;
    },
    async queryAlertList({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/alert/queryList", params);
      return data;
    },
    async saveAlertConfig({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/alert/saveAlertConfig", params);
      return data;
    },
    async getAlertConfig({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/alert/getAlertConfig", params);
      return data;
    },
    async deleteInventoryAlert({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/alert/delete", params);
      return data;
    },
    async saveInventoryAlert({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/alert/save", params);
      return data;
    },
    async queryAlertPartsList({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/alert/queryParts", params);
      return data;
    },
    async queryInventoryAndNotice({ commit, dispatch }, partsCodeArr = []) {
      const data = await dispatch(
        "inventory/getPartsInventoryList",
        {
          alertFlag: "1",
          partsCodeArray: partsCodeArr,
          findInvEmpty: "1"
        },
        { root: true }
      );
      if (data.data.list.length > 0) {
        const codes = [];
        const deduplicationList = data.data.list.filter(item => {
          if (!codes.includes(item.partsCode)) {
            codes.push(item.partsCode);
            return true;
          } else {
            return false;
          }
        });
        if (!deduplicationList || deduplicationList.length <= 0) return;
        const imgBase64 = require("@/assets/img/notice_warning.png");
        const itemHtml = deduplicationList.map(item => {
          return `<p class='color-gray2 notify-p2'>${item.partsName}${t("v213.inventory-is-below")}${item.alertQty}${t(
            "v213.item"
          )}</p>`;
        });
        Notification({
          title: "",
          customClass: "__global-message-notify",
          dangerouslyUseHTMLString: true,
          message: `<div class='disflex'>
        <div class='margin-right-8'><img class='width-24' src='${imgBase64}'></div>
        <div>
         <p class='title notify-p1'>${t("dashboard.stock-warning")}</p>
         ${itemHtml.join("")}
        </div>
         </div>`,
          duration: 5000,
          position: "bottom-right",
          onClick: () => commit("toInventoryQuery", partsCodeArr)
        });
      }
      return data;
    },
    async queryOutWarehousePrintDetail({ rootState }, params = {}) {
      const data = await rootState.http("/outbound/getPrintInfo", params);
      return data;
    },
    async queryPartsQtyByWarehouseTree({ rootState }, params = {}) {
      const data = await rootState.http("/warehouse/qtyTreeByParts", params);
      return data;
    },
    async queryWarehouseByInventory({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/findPartsInvByDimension", params);
      return data;
    },
    async queryPartsCostPrice({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/findPartsCostPrice", params);
      return data;
    },
    //根据入库单号批量查询仓库
    async queryQtyTreeByInbound({ rootState }, params = {}) {
      const data = await rootState.http("/warehouse/qtyTreeByInbound", params);
      return data;
    },
    async createInventoryCheck({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/stocktaking/create", params);
      return data;
    },
    async updateInventoryCheck({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/stocktaking/update", params);
      return data;
    },
    async deleteInventoryCheck({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/stocktaking/delete", params);
      return data;
    },
    async queryInventoryCheckDetail({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/stocktaking/queryDetail", params);
      return data;
    },
    async queryInventoryCheckList({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/stocktaking/queryList", params);
      return data;
    },
    async saveAllStocktaking({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/stocktaking/saveAllStocktaking", params);
      return data;
    },
    async saveAddPartialStocktakingParts({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/stocktaking/addPartialStocktakingParts", params);
      return data;
    },
    async queryStocktakingParts({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/stocktaking/queryStocktakingParts", params);
      return data;
    },
    async queryStocktaking({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/stocktaking/getStocktaking", params);
      return data;
    },
    async updateStocktakingPartsRow({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/stocktaking/stocktakingParts", params);
      return data;
    },
    async removePartialStocktakingParts({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/stocktaking/removePartialStocktakingParts", params);
      return data;
    },
    async queryPartialStocktakingUncheckedInventory({ rootState }, params = {}) {
      const data = await rootState.http("/inventory/stocktaking/queryPartialStocktakingUncheckedInventory", params);
      return data;
    }
  }
};

export default inventory;
